<dx-data-grid [dataSource]="dailyClockStatuses"
  keyExpr="date"
  [paging]="{ enabled: false }"
  (onCellPrepared)="onCellPrepared($event)">
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxi-column dataField="monthYearString"
    [visible]="false">
  </dxi-column>
  <dxi-column dataField="monthYearNumber"
    [groupIndex]="0"
    sortOrder="desc"
    groupCellTemplate="groupCellTemplate">
  </dxi-column>
  <dxi-column dataField="date"
    sortOrder="desc"
    caption="Giorno"
    [width]="170">
  </dxi-column>
  <dxi-column dataField="clocks"
    caption="Timbrature"
    [minWidth]="155"
    [allowSorting]="false">
  </dxi-column>
  <dxi-column dataField="isSaturday"
    [visible]="false">
  </dxi-column>
  <dxi-column dataField="isHoliday"
    [visible]="false">
  </dxi-column>
  <dxi-column dataField="isComplete"
    [visible]="false">
  </dxi-column>
  <dxi-column caption="Giustificativo"
    [minWidth]="130"
    cellTemplate="justificationTemplate"
  wordWrapEnabled="true"></dxi-column>
  <!-- [width] = 500-->

  <dxi-column caption=""
    [minWidth]="20"
  cellTemplate="editButtonTemplate"></dxi-column>
  <!-- [width] = 50-->

  <div *dxTemplate="let data of 'groupCellTemplate'">
    <div>
      {{ getMonthYearString(data) }}
    </div>
  </div>

  <div *dxTemplate="let data of 'justificationTemplate'">
    <div style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
      <strong>{{ data.data.justification }}</strong>
      <br>
        @if (data.data.note) {
          <span>{{ data.data.note }}</span>
        }
      </div>
    </div>


    <div *dxTemplate="let data of 'editButtonTemplate'">
      <dx-button icon="edit" stylingMode="text" (onClick)="onClick(data.row.data)"></dx-button>
    </div>
  </dx-data-grid>
